// extracted by mini-css-extract-plugin
export default {"Title":"Title_Title__CY4xP","Description":"Title_Description__1n4bu"};